import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getListings = () => api.get("/listings").then((r) => r.data);
export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const postNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const postGuide = (data) => api.post("/guide", data).then((r) => r.data);
export const postRentalAnalysis = (data) => api.post("/rental-analysis", data).then((r) => r.data);
export const postAppointment = (data) => api.post("/appointments", data).then((r) => r.data);
